export default "__VITE_ASSET__CFPtAw$E__"